import { styled } from '@mui/material/styles';
import { Stack, Typography } from '@mui/material';

export const MainStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
  paddingLeft: theme.spacing(13),
  paddingRight: theme.spacing(13),
  paddingTop: theme.spacing(3)
}));

export const SubtitleTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: '400'
})); 